import GLightbox from 'glightbox';

export let gallery = {

    videoSettings : {
        'openEffect' : 'none',
        'closeEffect' : 'none',				
        'videosWidth' : 1280,
        'videosHeight' : 720,
        youtube : {
            api : 'https://www.youtube.com/iframe_api',
            params : {
                enablejsapi : 1,
                autoplay : 1,		
                showinfo : 0,	
                rel : 0,	
                controls : 1,
            }
        }
    },

    init : function() {
        const gallery = GLightbox({
            'selector' : '.gallery__link',
            'openEffect' : 'none',
            'closeEffect' : 'none',
            // 'slideEffect' : '',
            'autoplayVideos' : true, 
        });

        const video = GLightbox({
            'selector' : '.video__link',
            ...this.videoSettings,
        });			
    }
}